import { LAYOUTS, ModalAlignmentEnum, } from '@voltmoney/types';
import { WIDGET } from '@voltmoney/schema';
import { ROUTE } from '../../../routes';
import { isMobile } from "../../../configs/utils";
import { heightMap } from "../../../configs/height";
import { downloadTemplate, goBack, shareOnWhatsAppCollateral } from "./action";
import { ACTION } from "./types";
const _isMobile = isMobile();
export const template = async (imageUrl, height, previewUrl, imageNameFromAPI, imageFileExtension) => ({
    layout: {
        id: ROUTE.PREVIEW_COLLATERAL,
        type: _isMobile ? LAYOUTS.LIST : LAYOUTS.MODAL,
        style: {
            isPartnerPlatform: true,
            alignment: ModalAlignmentEnum.RIGHT,
            height: heightMap[ROUTE.COLLATERAL_DOWNLOAD_INFO]
        },
        widgets: [{ id: 'previewCollateralScreen', type: WIDGET.PREVIEW_COLLATERAL_SCREEN }],
    },
    datastore: {
        previewCollateralScreen: {
            previewUrl: previewUrl,
            height: height,
            goBackAction: {
                type: ACTION.GO_BACK,
                routeId: ROUTE.PREVIEW_COLLATERAL,
                payload: {}
            },
            downloadAction: {
                type: ACTION.DOWNLOAD_TEMPLATE,
                routeId: ROUTE.PREVIEW_COLLATERAL,
                payload: {}
            },
            loading: false,
            imageNameFromAPI: imageNameFromAPI,
            imageFileExtension: imageFileExtension,
            shareOnWhatsAppAction: {
                type: ACTION.SHARE_IMAGE_ON_WHATSAPP,
                routeId: ROUTE.PREVIEW_COLLATERAL,
                payload: {}
            }
        }
    },
});
export const previewCollateralMF = {
    onLoad: async ({ asyncStorage, network, getHeight }, { imageUrl, previewUrl, imageNameFromAPI, imageFileExtension, collateralCategory }) => {
        return Promise.resolve(template(imageUrl, getHeight(), previewUrl, imageNameFromAPI, imageFileExtension));
    },
    actions: {
        [ACTION.GO_BACK]: goBack,
        [ACTION.DOWNLOAD_TEMPLATE]: downloadTemplate,
        [ACTION.SHARE_IMAGE_ON_WHATSAPP]: shareOnWhatsAppCollateral,
    }
};
